interface DashboardHeaderProps {
  userName: string;
  unreadCount: number;
}

export function DashboardHeader({ userName, unreadCount }: DashboardHeaderProps) {
  // Get current hour for greeting
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';

  // Get first name
  const firstName = userName?.split(' ')[0] || 'there';

  // Dynamic subtitle based on activity
  const subtitle = unreadCount > 0
    ? `You have ${unreadCount} ${unreadCount === 1 ? 'notification' : 'notifications'} waiting.`
    : "You're all caught up!";

  return (
    <div className="mb-6">
      <h1 className="text-heading-1 text-secondary">
        {greeting}, {firstName}
      </h1>
      <p className="text-grey-500 mt-1">{subtitle}</p>
    </div>
  );
}
